module.exports = {"multiTenant":true,"topPath":"/tsblms","tsqPath":"/tsblms_mgr"}


//////////////////
// WEBPACK FOOTER
// ./src/site.config.json
// module id = 31
// module chunks = 0